/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_Total_MembersInputs */

const en_admin_dashboard_total_members = /** @type {(inputs: Admin_Dashboard_Total_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Members`)
};

const de_admin_dashboard_total_members = /** @type {(inputs: Admin_Dashboard_Total_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitglieder Gesamt`)
};

const es_admin_dashboard_total_members = /** @type {(inputs: Admin_Dashboard_Total_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total de Miembros`)
};

const fr_admin_dashboard_total_members = /** @type {(inputs: Admin_Dashboard_Total_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total de membres`)
};

const it_admin_dashboard_total_members = /** @type {(inputs: Admin_Dashboard_Total_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Membri totali`)
};

const pt_br2_admin_dashboard_total_members = /** @type {(inputs: Admin_Dashboard_Total_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`membros no total`)
};

const pl_admin_dashboard_total_members = /** @type {(inputs: Admin_Dashboard_Total_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Łącznie członków`)
};

const hu_admin_dashboard_total_members = /** @type {(inputs: Admin_Dashboard_Total_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tagok összesen`)
};

const ro_admin_dashboard_total_members = /** @type {(inputs: Admin_Dashboard_Total_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Membri`)
};

/**
* | output |
* | --- |
* | "Total Members" |
*
* @param {Admin_Dashboard_Total_MembersInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_total_members = /** @type {((inputs?: Admin_Dashboard_Total_MembersInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Total_MembersInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_total_members(inputs)
	if (locale === "de") return de_admin_dashboard_total_members(inputs)
	if (locale === "es") return es_admin_dashboard_total_members(inputs)
	if (locale === "fr") return fr_admin_dashboard_total_members(inputs)
	if (locale === "it") return it_admin_dashboard_total_members(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_total_members(inputs)
	if (locale === "pl") return pl_admin_dashboard_total_members(inputs)
	if (locale === "hu") return hu_admin_dashboard_total_members(inputs)
	return ro_admin_dashboard_total_members(inputs)
});
export { admin_dashboard_total_members as "admin.dashboard.total_members" }